import React from "react"
import { FormattedMessage } from "react-intl"

import { LocaleFormattedDate } from "../../internationalization/LocaleFormatted"

export default function InventoryItemDetails({ inventory_item }) {
  return (
    <>
      <tr>
        <td style={{ width: "350px" }}>
          <label>
            <FormattedMessage id={"general.name"} />
          </label>
          :{" "}
        </td>
        <td>{inventory_item.sku.name}</td>
      </tr>
      <tr>
        <td>
          <label>
            <FormattedMessage id={"general.description"} />
          </label>
          :{" "}
        </td>
        <td>{inventory_item.sku.description}</td>
      </tr>
      <tr>
        <td>
          <label>
            <FormattedMessage id={"general.type"} />
          </label>
          :{" "}
        </td>
        <td>{inventory_item.sku.inventory_type.name}</td>
      </tr>
      <tr>
        <td>
          <label>
            <FormattedMessage id={"stock.uom"} />
          </label>
          :{" "}
        </td>
        <td>{inventory_item.uom}</td>
      </tr>
      <tr>
        <td>
          <label>
            <FormattedMessage id={"stock.lot"} />
          </label>
          :{" "}
        </td>
        <td>{inventory_item.lot_no}</td>
      </tr>
      <tr>
        <td>
          <label>
            <FormattedMessage id={"inventory.available_quantity"} />
          </label>
          :{" "}
        </td>
        <td>{inventory_item.available_quantity}</td>
      </tr>
      <tr>
        <td>
          <label>
            <FormattedMessage id={"stock.retest_date"} />
          </label>
          :{" "}
        </td>
        <td>
          <LocaleFormattedDate date={inventory_item.retest_date} shouldParse={true} showTime={false} />
        </td>
      </tr>
      <tr>
        <td>
          <label>
            <FormattedMessage id={"inventory.last_received_date"} />
          </label>
          :{" "}
        </td>
        <td>
          <LocaleFormattedDate date={inventory_item.last_received_date} shouldParse={true} />
        </td>
      </tr>
    </>
  )
}
